import { render, staticRenderFns } from "./MoreVideos.vue?vue&type=template&id=06a92daf&scoped=true&"
import script from "./MoreVideos.vue?vue&type=script&lang=js&"
export * from "./MoreVideos.vue?vue&type=script&lang=js&"
import style0 from "./MoreVideos.vue?vue&type=style&index=0&id=06a92daf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a92daf",
  null
  
)

export default component.exports